module.exports = __webpack_public_path__ + "img/cbrr1.af16287e.gif";